import { func } from 'prop-types'
import React from 'react'

import ButtonStandard from '../../ButtonStandard'
import Type from '../../Type'
import Icon from '../../Icon'
import TextAlign from '../../TextAlign'
import Stack from '../../Stack'
import OutlineHeading from '../../OutlineHeading'

import styles from './ViewSelector.module.scss'

const ViewSelector = ({ setFullScreen, setViewModeChosen }) => {
  const selectInline = () => {
    setFullScreen(false)
    setViewModeChosen(true)
    document.body.classList.remove('has-locked-scrolling-desktop')
  }

  const selectFullScreen = () => {
    setFullScreen(true)
    setViewModeChosen(true)
  }

  return (
    <div className={styles.ViewSelector}>
      <TextAlign center>
        <Stack gap="small">
          <div className={styles.HeadingWrapper}>
            <OutlineHeading heading="View in full screen?" subHeading=" " />
          </div>
          <div>
            <ButtonStandard primary onClick={selectFullScreen}>
              <span className={styles.ButtonLabel}>Enter full screen</span>
              <Icon
                type="full-screen"
                className={styles.Icon}
                width={18}
                height={18}
              />
            </ButtonStandard>
          </div>
          <div>
            <button className={styles.TextButton} onClick={selectInline}>
              <Type size="body4">No, thanks</Type>
            </button>
          </div>
        </Stack>
      </TextAlign>
    </div>
  )
}

ViewSelector.propTypes = {
  setFullScreen: func,
  setViewModeChosen: func
}

export default ViewSelector
